module.exports = __webpack_public_path__ + "img/tarj2-3.b7db245d.svg";